<div class="card-header pb-0">
  <div class="media-space-between">
    <h4>{{ "dashboard.admin.lpReview.title" | translate }}</h4>
    <div class="d-flex align-items-end" style="gap: 10px;">
      <app-export class="m-auto" [data]="receivedLocation"></app-export>
      <app-refresh-button [state]="fetchingLocationPartnerPreviewState" [date]="cachedAt" (buttonClick)="onClickRefreshCache()"></app-refresh-button>
    </div>
  </div>
</div>
<div class="card-body" id="dashboard.admin.lpReview.title">
  <div class="table-responsive data-table">
    <form id="dashboard.admin.lpReview.title">
      <table class="table table-striped table-border-vertical">
        <thead>
          <tr>
            <th>
              {{ "dashboard.admin.lpReview.companyName" | translate }}
            </th>
            <ng-container *ngFor="let column of last7Days">
              <th>
                {{ column | localizedDate }}
              </th>
            </ng-container>
            <th>{{ "dashboard.admin.lpReview.averageViews" | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="!loading">
          <tr
            *ngFor="
              let item of lastWeekLocationPartnerReview?.locationPartnerChecks
            "
          >
            <td>
              <ngb-highlight [result]="item.companyName"></ngb-highlight>
            </td>
            <td *ngFor="let views of item.views">
              {{ views }}
            </td>

            <td>
              {{ item.average.toFixed(3) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="loading && !forbidden">
        <ng-container style="float: right" class="flex">
          <div class="loader-box">
            <div class="loader-34"></div>
          </div>
          <h6 class="col align-self-center f-w-600" style="text-align: center">
            {{ "fetching" | translate }}
          </h6>
        </ng-container>
      </div>
      <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
        {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
      </div>
      <div
        *ngIf="resultCountLOcationPartnerPreview == 0 && !loading && !forbidden"
        class="d-flex justify-content-center m-t-20"
      >
        {{ "noData" | translate }}
      </div>
    </form>
  </div>
  <app-pager
    [count]="resultCountLOcationPartnerPreview"
    [pageSize]="pagerLocationPartnerPreview.pageSize"
    [pageNumber]="pagerLocationPartnerPreview.pageNumber"
    (emitChangePage)="changePage($event)"
    (emitChangePageSize)="itemsPerPageChange($event)"
  ></app-pager>
</div>
